import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { api, errMsg } from "../lib/api";
import { Btn, Card, Field, Input } from "../components/common";

export default function ChangePassword() {
  const { user, refreshUser, logout } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const forced = user.must_change_password;
  const save = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 12) return toast.error("New password must be at least 12 characters");
    if (f.new_password !== f.confirm) return toast.error("The two new passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success(forced ? "Password changed. Welcome!" : "Password changed.");
      await refreshUser();
      if (!forced) nav("/");
    } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="max-w-lg mx-auto fade-up">
      <Card>
        <KeyRound className="h-10 w-10 text-[#C85A32]" />
        <h1 className="font-serif text-2xl font-bold mt-3">{forced ? "Choose your own password" : "Change password"}</h1>
        <p className="text-[#6E6259] mt-1">{forced ? `Welcome, ${user.name}. For your security, please replace the temporary password given by the Parish Office before continuing.` : `Signed in as ${user.username}. Enter your current password, then your new one.`}</p>
        <form onSubmit={save} className="space-y-4 mt-6">
          <Field label={forced ? "Temporary password" : "Current password"}><Input data-testid="cp-current-input" type="password" value={f.current_password} onChange={set("current_password")} required /></Field>
          <Field label="New password (at least 12 characters; a short sentence works well)"><Input data-testid="cp-new-input" type="password" value={f.new_password} onChange={set("new_password")} required /></Field>
          <Field label="Type the new password again"><Input data-testid="cp-confirm-input" type="password" value={f.confirm} onChange={set("confirm")} required /></Field>
          <Btn type="submit" loading={busy} className="w-full" data-testid="cp-submit-button">Save new password</Btn>
          {forced ? <Btn type="button" v="ghost" className="w-full" onClick={logout} data-testid="cp-logout-button">Sign out</Btn>
            : <Btn type="button" v="ghost" className="w-full" onClick={() => nav(-1)} data-testid="cp-cancel-button">Cancel</Btn>}
        </form>
      </Card>
    </div>
  );
}
